import React from 'react';
import cx from '../../../styles';

const  EmptyPlaceholder = ({content, removeClass = false}) => {
    return (
        <div className={cx(removeClass ? "" : "shadow-card", 'no-result-text')}>
            {
                content
                ? content
                : <img src={'/assets/images/empty-placeholder.png'} alt="EmptyPlaceholder" loading="lazy"/>
            }
        </div>
    );
};

export default EmptyPlaceholder;